/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import HexGroup from 'solis/type/hex/group';

import BoardFrontierType from 'solis/logic/board/frontier.type';
import BoardProximity from 'solis/logic/board/proximity';
import ZoneUsers from 'solis/logic/board/zone/users';


// Classifies board zones against the source colony with the same reachability check
// the create-influence validation uses, so the influence region always agrees with it.
export default class
{
  constructor (board, colony)
  {
    this.board = board;
    this.colony = colony;

    this.hexes = null;
  }


  matches (zone)
  {
    return this.getHexes().contains(zone.getAbsoluteHex());
  }


  equals (other)
  {
    return other !== null && other.constructor === this.constructor && this.board.equals(other.board) && this.colony.equals(other.colony);
  }


  getHexes ()
  {
    if (this.hexes === null)
    {
      this.hexes = this.calculateHexes();
    }

    return this.hexes;
  }


  calculateHexes ()
  {
    const proximity = new BoardProximity(this.board, BoardFrontierType.Zone);

    const zones = this.board.getZones().values().filter(zone =>
    {
      return this.isInRange(zone, proximity)
    });

    return new HexGroup(zones.map(zone => zone.getAbsoluteHex()));
  }


  isInRange (zone, proximity)
  {
    return new ZoneUsers(zone).isNeighborAccessible(proximity, this.colony.cass.id);
  }


};
